module.exports = __webpack_public_path__ + "img/14.db7c1fa7.png";